import React from "react";
import { AlertCircle, X } from "lucide-react";

interface ErrorModalProps {
  show: boolean;
  title?: string;
  message: string;
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  show,
  title = "Error",
  message,
  onClose,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-neutral-900 rounded-xl max-w-md w-full shadow-2xl border border-neutral-800">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-neutral-800">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-red-500/10 rounded-full flex items-center justify-center">
              <AlertCircle className="w-5 h-5 text-red-400" />
            </div>
            <h2 className="text-lg font-semibold text-white">{title}</h2>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-neutral-800 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-neutral-400" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-6">
            <p className="text-neutral-400 leading-relaxed">{message}</p>
          </div>

          {/* Action Button */}
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="
                bg-red-500 hover:bg-red-600
                text-white px-6 py-2.5 rounded-lg font-medium 
                transition-all duration-300 ease-out
                shadow-lg hover:shadow-xl hover:shadow-red-500/20
                transform hover:-translate-y-0.5
                active:scale-95 active:translate-y-0
                focus:outline-none focus:ring-2 focus:ring-red-500/50
              "
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
